import React from "react";

const StandingsTable = ({ standings = [], teams, group }) => {
  // Sort standings by points (highest first)
  const sortedStandings =
    [...standings].sort((a, b) => b.points - a.points) || [];

  return (
    <div className="overflow-x-auto">
      <div className="p-4 bg-white border-b">
        <h3 className="text-lg font-semibold text-blue-700">
          Bảng Xếp Hạng - Bảng {group}
        </h3>
      </div>
      <table className="min-w-full">
        <thead>
          <tr className="bg-gray-50">
            <th className="px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider pl-2">
              Thứ hạng
            </th>
            <th className="px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Mã đội
            </th>
            <th className="px-1 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Tên VĐV
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Trận
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Thắng
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Thua
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Bỏ cuộc
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Điểm thắng
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Điểm thua
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Hiệu số
            </th>
            <th className="px-1 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
              Điểm
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {sortedStandings.map((standing = {}, index) => {
            const team = teams.find((team) => team.id === standing.teamId);
            const differential = standing.pointsFor - standing.pointsAgainst;

            return (
              <tr
                key={standing.teamId}
                className={index < 2 ? "bg-blue-50" : ""}
              >
                <td className="px-1 py-2 pl-2">
                  <div className="flex items-center">
                    <span
                      className={`flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium ${
                        index < 2
                          ? "bg-blue-100 text-blue-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {index + 1}
                    </span>
                  </div>
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm font-medium text-gray-900">
                  {team?.id}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-gray-500">
                  {team?.player1} & {team?.player2}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center text-gray-500">
                  {standing.played}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center text-gray-500">
                  {standing.won}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center text-gray-500">
                  {standing.lost}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center text-gray-500">
                  {standing.forfeited}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center text-gray-500">
                  {standing.pointsFor}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center text-gray-500">
                  {standing.pointsAgainst}
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-sm text-center">
                  <span
                    className={
                      differential > 0
                        ? "text-green-600"
                        : differential < 0
                        ? "text-red-600"
                        : "text-gray-500"
                    }
                  >
                    {differential > 0 ? "+" : ""}
                    {differential}
                  </span>
                </td>
                <td className="px-1 py-2 whitespace-nowrap text-center">
                  <span className="px-1 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full block w-[24px] h-[24px]">
                    {standing.points}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StandingsTable;
